/* bf-write-review-link: review-request emails link to /products/<handle>#write-review.
   On arrival, open the Stamped "Write a Review" form and scroll it into view.
   Added 2026-10-07 for the Klaviyo post-delivery review flow. Does nothing without the hash. */
(function () {
  if (!/^#write-review/i.test(window.location.hash)) return;

  var started = Date.now();
  var opened = false;

  function headerOffset() {
    var header = document.querySelector('#header-group');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollTo(el, behavior) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 18;
    // 'instant' skips the theme's CSS smooth scrolling, which stalls in background tabs.
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'instant' });
  }

  function tick() {
    var widget = document.querySelector('#stamped-main-widget');
    var button = widget && widget.querySelector('.stamped-summary-actions-newreview');

    if (button && !opened) {
      var form = widget.querySelector('.new-review-form');
      if (!form || !form.classList.contains('stamped-visible')) button.click();
      opened = true;
      // Lazy images above the widget keep pushing it down, so re-aim a few times
      // until it settles. Stop as soon as the visitor scrolls on their own.
      var userMoved = false;
      ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
        window.addEventListener(evt, function () { userMoved = true; }, { once: true, passive: true });
      });
      [400, 1200, 2200, 3500, 5000].forEach(function (ms) {
        window.setTimeout(function () {
          if (userMoved) return;
          var target = widget.querySelector('.new-review-form.stamped-visible') || widget;
          var top = target.getBoundingClientRect().top;
          if (Math.abs(top - headerOffset() - 18) > 40) scrollTo(target);
        }, ms);
      });
      return;
    }

    // The widget can render late; nudge it into view so a lazy loader fires.
    if (widget && !button && Date.now() - started > 2500) scrollTo(widget);

    if (Date.now() - started < 25000) window.setTimeout(tick, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
